import React, { Fragment } from 'react';
import { Button, Checkbox, Form, Grid, Header, Icon, Input, Label, Loader, Popup, Table } from 'semantic-ui-react';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import { fetchCurrentAcademicYear } from '../../Lookups/util';
import { FiltersOnStyle } from '../../Professor/ProfessorInputGrades/css';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const NoDataMessage = () => <p><br /><br />Nema predmeta.</p>;


export default class CourseEnroll extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            filterData: [],
            currentAcademicYear: null,
            final: false,
            loading: true,
            showFiltersOnButton: false,
            showFilterMode: false,

        };
        this.getCourses = this.getCourses.bind(this);
        this.enrollStudent = this.enrollStudent.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getSemesters = this.getSemesters.bind(this);
    }

    componentDidMount() {
        this.getSemesters();
        axios.all([fetchCurrentAcademicYear()])
            .then(axios.spread((currentAcademicYearRes) => {
                this.getCourses(currentAcademicYearRes.data.id);
                this.setState({ currentAcademicYear: currentAcademicYearRes.data.id });
            }));
    }

    enrollStudent(courseId, collision = false) {
        axios.post(`students/enroll/${this.props.studentStudyProgramId}/course/${courseId}/${collision}`).then(res => {
            // eslint-disable-next-line no-unused-expressions
            collision ? toast('Student je uspješno upisan na predmet kolizije.') : toast('Student je uspješno upisan na predmet.');
            this.setState({ index: null });
        })
            .catch(err => {
                if (err.response.data === 'Student is not enrolled in this semester!') {
                    toast('Student nije upisan u odabrani semestar!');
                } else if (err.response.data === 'Student is enrolled in this semester more than once!') {
                    toast('Student je upisan u odabrani semestar više puta!');
                } else if (err.response.data === 'Student is already enrolled in this course implementation!') {
                    toast('Student je već upisan na odabrani predmet!');
                } else if (err.response.data === 'Student is not yet enrolled in that study year!') {
                    toast('Student nije upisan u akademsku godinu na kojoj se nalazi odabrani predmet!');
                } else toast('Došlo je do greške! Student nije upisan na predmet.');
                this.setState({ index: null });
            });
    }


    getCourses(currentAcademicYear) {
        let obj = {
            finalCourse: this.state.final
        };
        axios.post(`course/implementations/${this.props.studentStudyProgramId}/${currentAcademicYear}/`, { ...obj })
            .then(res => {
                this.setState({
                    data: res.data, loading: false, final: !this.state.final, filterMode: false, name: ''
                });
            })
            .catch(err => {
                console.log('Failed to fetch courses.');
            });
    }
    getSemesters() {
        axios.get('/semester-names')
            .then(res => {
                this.setState({
                    semesterOptions: res.data.filter(e => (e.name !== 'ostalo' && e.name !== 'ljetna škola')).map(el => ({
                        ...el, key: el.id, value: el._key, text: el.name
                    }))
                });
            });
    }

    getDataToRender() {
        if (this.props.gapYear) {
            if (this.state.filterMode) {
                return this.state.filterData.filter(el => el.collisionApproved);
            }
            return this.state.data.filter(el => (el.collisionApproved));
        }

        if (this.state.filterMode) {
            return this.state.filterData;
        }
        return this.state.data;
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            filterMode: true,
            [name]: value
        });
        let filterData = [];
        if (name === 'semester') {
            filterData = this.state.data.filter((e) => (e.semesters[0].name._key.toLowerCase().match(value.toLowerCase())));
            if (this.state.name) { filterData = filterData.filter((e) => (e.courseBasic.name.toLowerCase().match(this.state.name.toLowerCase()))); }
        }
        if (name === 'name') {
            filterData = this.state.data.filter((e) => (e.courseBasic.name.toLowerCase().match(value.toLowerCase())));
            if (this.state.semester) { filterData = filterData.filter((e) => (e.semesters[0].name._key.toLowerCase().match(this.state.semester.toLowerCase()))); }
        }


        this.setState({
            filterData
        });
    }

    render() {
        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;

        return (
            <div>
                {/* <h3>Spisak predmeta</h3> */}

                <Form>
                    <Form.Group widths="equal">
                        <Form.Field
                            required
                            control={Input}
                            label="Naziv predmeta"
                            placeholder="Unesite predmet"
                            name="name"
                            value={this.state.name}
                            onChange={this.handleInputChange}

                        />
                        <Form.Field>
                            <label>Semestar</label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odaberite semestar"
                                value={this.state.semester}
                                onChange={this.handleInputChange}
                                name="semester"
                                options={this.state.semesterOptions}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                    </Form.Group>

                    <Form.Field
                        type="checkbox"
                        control={Checkbox}
                        name="final"
                        value={this.state.final}
                        onChange={() => this.getCourses(this.state.currentAcademicYear)}
                        checked={!this.state.final}
                        label="Prikaži samo završne predmete"
                    />


                </Form>

                {this.getDataToRender().length !== 0 ?
                    <Table celled selectable compact>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell width="1">R. br.</Table.HeaderCell>
                                <Table.HeaderCell colSpan="2">Naziv</Table.HeaderCell>
                                <Table.HeaderCell><Header as="h4">
                                    <Header.Content>
                                        Napomena
                                        <Header.Subheader>Predmet / implementacija</Header.Subheader>
                                    </Header.Content>
                                </Header></Table.HeaderCell>
                                <Table.HeaderCell />
                            </Table.Row>
                        </Table.Header>
                        <Table.Body> {this.getDataToRender().map((el, index) =>
                            (<Table.Row key={index}>
                                <Table.Cell verticalAlign="middle">
                                    {index + 1}.
                                </Table.Cell>
                                <Popup
                                    content={el.semesters[0].name._key === 'winter semester' ? el.collisionApproved ? 'Implementacija predmeta u zimskom semestru - kolizija' : 'Implementacija predmeta u zimskom semestru' : el.collisionApproved ? 'Implementacija predmeta u ljetnom semestru - kolizija' : 'Implementacija predmeta u ljetnom semestru'}
                                    hideOnScroll
                                    position="left center"
                                    trigger={<Table.Cell verticalAlign="middle" colSpan="2">
                                        {/* eslint-disable-next-line react/jsx-no-undef */}
                                        <Grid columns={1} centered className="stackable">
                                            <Grid.Row verticalAlign="middle">
                                                <Grid.Column width="10">
                                                    <span >  { el.semesters[0].name._key === 'winter semester' ? <Icon name="snowflake" color="blue" /> : <Icon name="sun" color="yellow" />} {el.courseBasic.name} {el.code ? ' | ' + el.code : ''}</span>
                                                </Grid.Column>
                                                <Grid.Column width="6" verticalAlign="middle" textAlign="right">
                                                    <span style={{ color: '#a6a4a1' }}>{el.courseComment}</span>
                                                </Grid.Column>
                                            </Grid.Row>
                                        </Grid>

                                    </Table.Cell>}
                                />
                                <Table.Cell verticalAlign="middle">
                                    {el.collisionApproved &&
                                    // eslint-disable-next-line react/jsx-no-undef
                                    <Label as="a" basic>
                                        <Icon name="random" /> Kolizija
                                    </Label>}
                                    {(el.courseBasic.comment && el.comment) ? <Label as="a" basic>
                                        <Icon name="comment alternate outline" /> {el.courseBasic.comment + ' / ' + el.comment}
                                    </Label> : el.courseBasic.comment ? <Label as="a" basic>
                                        <Icon name="comment alternate outline" /> {el.courseBasic.comment}
                                    </Label> : el.comment ? <Label as="a" basic>
                                        <Icon name="comment alternate outline" /> {el.comment}
                                    </Label> : ''}
                                </Table.Cell>
                                {/* <Table.Cell verticalAlign="middle"> */}
                                {/*    {(el.courseBasic.comment && el.comment) ? el.courseBasic.comment + ' / ' + el.comment : el.courseBasic.comment ? el.courseBasic.comment : el.comment ? el.comment : ''} */}
                                {/* </Table.Cell> */}

                                <Table.Cell textAlign="center" verticalAlign="middle">
                                    {this.state.showConnfiramtion && index === this.state.index ?
                                        // eslint-disable-next-line react/jsx-no-undef
                                        <Fragment>
                                            <h4>Odaberite način upisa</h4>
                                            <span> <Button
                                                style={FiltersOnStyle}
                                                size="medium"
                                                color="blue"
                                                primary
                                                onClick={() => this.enrollStudent(el.id)}
                                            >
                                                {/* <Icon name="sign-in alternate" /> */}
                                                Upiši</Button> <Button
                                                style={FiltersOnStyle}
                                                size="medium"
                                                color="blue"
                                                basic
                                                onClick={() => this.enrollStudent(el.id, true)}
                                            >
                                                    Upiši na koliziju</Button></span>


                                        </Fragment>


                                        :
                                        <Button
                                            style={FiltersOnStyle}
                                            icon
                                            labelPosition="right"
                                            size="medium"
                                            color="blue"
                                            basic
                                            active={this.state.index === index}
                                            onClick={el.collisionApproved ? () => this.setState({ showConnfiramtion: true, index }) :
                                                () => this.setState({ showConnfiramtion: false, index }, () => this.enrollStudent(el.id))}
                                        > <Icon name="sign-in alternate" />Upiši</Button>
                                    }

                                    {/* <Popup */}
                                    {/*    content="Upiši na predmet" */}
                                    {/*    position="top center" */}
                                    {/*    trigger={ */}
                                    {/*        <Button */}

                                    {/*            // circular */}
                                    {/*            style={FiltersOnStyle} */}
                                    {/*            icon */}
                                    {/*            labelPosition="right" */}
                                    {/*            // icon="sign-in alternate" */}
                                    {/*            size="medium" */}
                                    {/*            color="blue" */}
                                    {/*            basic */}
                                    {/*            onClick={() => this.enrollStudent(el.id)} */}
                                    {/*        > <Icon name="sign-in alternate" />Upiši</Button>} */}
                                    {/* /> */}
                                    {/* {el.collisionApproved && <Popup */}
                                    {/*    content="Upiši na predmet kao koliziju" */}
                                    {/*    position="top center" */}
                                    {/*    trigger={ */}
                                    {/*        <Button */}

                                    {/*            // circular */}
                                    {/*            style={FiltersOnStyle} */}
                                    {/*            icon */}
                                    {/*            labelPosition="right" */}
                                    {/*            // icon="sign-in alternate" */}
                                    {/*            size="medium" */}
                                    {/*            color="orange" */}
                                    {/*            basic */}
                                    {/*            onClick={() => this.enrollStudent(el.id, true)} */}
                                    {/*        > <Icon name="random" />Upiši</Button> */}
                                    {/*    } */}

                                </Table.Cell>
                            </Table.Row>))}
                        </Table.Body>
                    </Table>
                    : <NoDataMessage />
                }
                <ToastContainer hideProgressBar />

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/CourseEnroll.js